import { Col, Flex, Form, Row } from "antd"
import PropTypes from "prop-types"
import { durationRule, TRIP_PRICE } from "../../utils/constants"
import { useTranslation } from "react-i18next"
import { InfoTooltip } from "ui/Tooltip/InfoTooltip"
import { BufferTime } from "../BufferTime"
import { ExperienceDuration } from "../ExperienceDuration"

export const DurationFormItems = ({ form, expandedRowData }) => {
  const [t] = useTranslation()
  return (
    <Row gutter={16}>
      <Col span={24} md={12} sm={24}>
        <Form.Item
          name={TRIP_PRICE.DURATION}
          label={t("experiences.scheduling.sections.length_and_rates.experience_duration")}
          required
          rules={[durationRule(t)]}
        >
          <ExperienceDuration form={form} expandedRowData={expandedRowData} />
        </Form.Item>
      </Col>
      <Col span={24} md={12} sm={24}>
        <Form.Item
          name={TRIP_PRICE.BUFFER_TIME}
          label={
            <Flex align="center" gap="small">
              {t("experiences.scheduling.sections.length_and_rates.buffer_time")}
              <InfoTooltip title={t("experiences.scheduling.sections.length_and_rates.buffer_time_info")} />
            </Flex>
          }
        >
          <BufferTime form={form} expandedRowData={expandedRowData} />
        </Form.Item>
      </Col>
    </Row>
  )
}

DurationFormItems.propTypes = {
  form: PropTypes.object.isRequired,
  expandedRowData: PropTypes.shape({
    trip_duration: PropTypes.number,
    trip_buffer_time: PropTypes.number,
  }),
};